import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';
import metadata from './block.json';
import MainComponent from './MainComponent';

registerBlockType(metadata.name, {
    edit: Edit,
});


// Ensure the script runs after the DOM is fully loaded
// document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('flat-ui-root');
    if (rootElement) {
        ReactDOM.render(<MainComponent />, rootElement);
    }
// });
